import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Calendar, MessageCircle, Clock, Shield, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { fadeUp, stagger } from '@/lib/motion';

export default function GraciasPage() {
  return (
    <div className="min-h-[80vh] bg-[#F8FAFC]">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:py-24">
        <motion.div initial="hidden" animate="visible" variants={stagger} className="text-center mb-12">
          <motion.div variants={fadeUp} className="w-20 h-20 mx-auto mb-6 rounded-full bg-emerald-50 flex items-center justify-center border-2 border-emerald-100">
            <CheckCircle className="w-10 h-10 text-emerald-500" />
          </motion.div>
          <motion.h1 variants={fadeUp} className="text-3xl sm:text-4xl font-semibold mb-3" style={{fontFamily:'Syne,sans-serif'}}>¡Gracias por tu interés!</motion.h1>
          <motion.p variants={fadeUp} className="text-lg text-[#64748B] max-w-md mx-auto">Hemos recibido tu solicitud. Un especialista ALLCOM se contactará contigo en menos de 24 horas hábiles.</motion.p>
        </motion.div>

        {/* Next Steps */}
        <motion.div variants={fadeUp} className="grid sm:grid-cols-3 gap-4 mb-12">
          {[
            { icon: Clock, title: 'Respuesta rápida', desc: 'Nuestro equipo revisará tu solicitud en las próximas horas.' },
            { icon: Users, title: 'Especialista asignado', desc: 'Un ejecutivo con experiencia en tu industria te contactará.' },
            { icon: Shield, title: 'Sin compromiso', desc: 'La asesoría inicial y demo son completamente gratuitas.' },
          ].map((step, i) => (
            <div key={i} className="p-5 rounded-xl bg-white border border-slate-200 shadow-sm text-center">
              <step.icon className="w-6 h-6 text-[#0EA5E9] mx-auto mb-3" />
              <h3 className="text-sm font-semibold mb-1">{step.title}</h3>
              <p className="text-xs text-[#64748B]">{step.desc}</p>
            </div>
          ))}
        </motion.div>

        {/* CTAs */}
        <motion.div variants={fadeUp} className="flex flex-col sm:flex-row gap-3 justify-center mb-12">
          <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 transition-colors shadow-lg">
            Volver al inicio <ArrowRight className="w-4 h-4" />
          </Link>
          <a href="https://wa.me/56975294340" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold text-emerald-600 border border-emerald-200 rounded-xl hover:bg-emerald-50 transition-colors">
            <MessageCircle className="w-4 h-4" /> WhatsApp directo
          </a>
        </motion.div>

        {/* Explore more */}
        <motion.div variants={fadeUp} className="text-center">
          <p className="text-xs text-[#64748B] mb-4">Mientras tanto, explora nuestras soluciones más populares:</p>
          <div className="flex flex-wrap justify-center gap-2">
            <Link to="/soluciones/autoservicio-self-checkout" className="text-xs px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-600 hover:text-[#0EA5E9] hover:border-sky-200 transition-colors shadow-sm">Autoservicio & Self-Checkout</Link>
            <Link to="/servicios/piloto" className="text-xs px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-600 hover:text-[#0EA5E9] hover:border-sky-200 transition-colors shadow-sm">Programa Piloto 30 días</Link>
            <Link to="/casos" className="text-xs px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-600 hover:text-[#0EA5E9] hover:border-sky-200 transition-colors shadow-sm">Casos de Éxito</Link>
            <Link to="/servicios/arriendo-leasing" className="text-xs px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-600 hover:text-[#0EA5E9] hover:border-sky-200 transition-colors shadow-sm">Arriendo & Leasing</Link>
            <Link to="/ia/allcom-ia" className="text-xs px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-600 hover:text-[#8B5CF6] hover:border-violet-200 transition-colors shadow-sm">ALLCOM IA</Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
